import React, { useState } from 'react'
import { apiGet } from '../../../generic/Api_Functions'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { DefaultAccordion } from '../../../generic/DefaultAccordion'
import { useSmartInterval } from '../../../generic/hooks/useSmartInterval'
import FabricationOrder from './FabricationOrder'
import { CircularProgress, Stack, Typography } from '@mui/material'

/**
* @typedef {import("../../../generic/utilities/objectStructures/toolwindows/FabricationOrder").FabricationOrder} FabricationOrder Fabrication Order object
*/

const FabricationOrders = () => {
  const { t_ } = useSmartTranslation()
  /** @type {[FabricationOrder[],  React.Dispatch<SetStateAction<FabricationOrder[]>>]} */
  const [fabricationOrders, setFabricationOrders] = useState(null)
  const [expandedAccordion, setExpandedAccordion] = useState(false)

  const fabricationOrdersInterval = useSmartInterval(
    async () => {
      return await apiGet('toolTable/fabricationOrders')
    },
    2000,
    (data) => {
      if (data != null) {
        setFabricationOrders(data)
      }
    }, false)

  return (
    <DefaultAccordion
      onExpandedStatusChange={(expanded) => {
        setExpandedAccordion(expanded)
        fabricationOrdersInterval(expanded)
      }}
      headerRender={t_('FOs - Part References')}
      defaultExpanded={false}
      headerSx={{ backgroundColor: theme => theme.palette.background.default }}
      contentSx={{ backgroundColor: theme => theme.palette.background.default }}
    >
      {expandedAccordion
        ? fabricationOrders == null
          ? <Stack sx={{ width: '100%', height: '5vh' }} direction='row' justifyContent='center' alignItems='center'><CircularProgress size='5rem' /></Stack>
          : fabricationOrders?.length > 0
            ? fabricationOrders?.map((fo) => {
              return (
                <FabricationOrder key={fo.id} fabricationOrder={fo} />
              )
            })
            : (
              <Stack sx={{ width: '100%', height: '5vh' }} direction='row' justifyContent='center' alignItems='center'>
                <Typography color='primary' fontSize='1.5rem'>{t_('No data to display')}</Typography>
              </Stack>
              )
        : null}
    </DefaultAccordion>
  )
}

export default FabricationOrders
